import LoadingBanner from 'components/banners/LoadingBanner';
import React from 'react';
import Loadable from 'react-loadable';

/**
 * Create the loading icon to indicate the element is be loaded.
 * @return {object} the loading icon element.
 */
const LoadingIcon = () => <LoadingBanner/>;

export const LoadableAccount = Loadable({
  loader: () => import('containers/account'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableCohort = Loadable({
  loader: () => import('containers/inputs/cohort'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableCohorts = Loadable({
  loader: () => import('containers/inputs/cohorts'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadablePersonnel = Loadable({
  loader: () => import('containers/inputs/personnel'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableHumans = Loadable({
  loader: () => import('containers/inputs/humans'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableHuman = Loadable({
  loader: () => import('containers/inputs/human'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableDatasets = Loadable({
  loader: () => import('containers/datasets'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableDatasetManagement = Loadable({
  loader: () => import('containers/datasetManagement'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableDocumentation = Loadable({
  loader: () => import('containers/documentation'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableEngineJobManagement = Loadable({
  loader: () => import('containers/engineJobManagement'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableFlight = Loadable({
  loader: () => import('containers/inputs/flight'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableFlights = Loadable({
  loader: () => import('containers/inputs/flights'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableFlowControl = Loadable({
  loader: () => import('containers/flowControl'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableFlyPro = Loadable({
  loader: () => import('containers/scheduler/flypro'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableGroups = Loadable({
  loader: () => import('containers/inputs/groups'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableGroup = Loadable({
  loader: () => import('containers/inputs/group'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableLesson = Loadable({
  loader: () => import('containers/inputs/lesson'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableLessonPhase = Loadable({
  loader: () => import('containers/inputs/lessonPhase'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableLogin = Loadable({
  loader: () => import('containers/login'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableManagement = Loadable({
  loader: () => import('containers/userManagement'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableManagedItems = Loadable({
  loader: () => import('containers/inputs/managedItems'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableReport = Loadable({
  loader: () => import('containers/inputs/dashboardDataExport'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableAvailabilityReport = Loadable({
  loader: () => import('containers/inputs/availabilityDataExport'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableResource = Loadable({
  loader: () => import('containers/inputs/resource'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableResourceType = Loadable({
  loader: () => import('containers/inputs/resourceType'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableResourceTypes = Loadable({
  loader: () => import('containers/inputs/resourceTypes'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSettings = Loadable({
  loader: () => import('containers/scheduler/parameters'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableCatInputs = Loadable({
  loader: () => import('containers/simulation/catInputs'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableCatOutputs = Loadable({
  loader: () => import('containers/simulation/catOutputs'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSchool = Loadable({
  loader: () => import('containers/inputs/school'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSchools = Loadable({
  loader: () => import('containers/inputs/schools'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSimulationParams = Loadable({
  loader: () => import('containers/simulation/parameters'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSyllabi = Loadable({
  loader: () => import('containers/inputs/syllabi'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableSyllabus = Loadable({
  loader: () => import('containers/inputs/syllabus'),
  loading() {
    return <LoadingIcon/>;
  }
});

export const LoadableTrainingFacility = Loadable({
  loader: () => import('containers/inputs/trainingFacility'),
  loading() {
    return <LoadingIcon/>;
  }
});
